import { useState, useRef } from 'preact/hooks';

import request from '@/api/request';
import { serialize, log } from '@/utils';
import useDebouncedCallback from './useDebouncedCallback';

export default function useRequest({
	url = '',
	method = 'post',
	json,
	headers = {},
	data = {},
	onSuccess = () => {},
	onError = () => {},
	allow = true,
	spoof = false
}) {
	const [response, setResponse] = useState({});
	const [error, setError] = useState(null);
	const cancel = useRef(() => {});

	function doRequest({ callback } = {}) {
		if (!allow) {
			return;
		}
		if (spoof) {
			log('Request was disabled, data:', data);
			onSuccess({ code: 200 });
			if (typeof callback === 'function') {
				callback();
			}
			return;
		}
		const { promise, abort } = request(url, {
			method,
			headers: {
				'Content-Type': `application/${
					json ? 'json' : 'x-www-form-urlencoded; charset=UTF-8'
				}`,
				...headers
			},
			body: json ? JSON.stringify(data) : serialize(data)
		});

		cancel.current = abort;

		return promise
			.then(response => response.json())
			.then(jsonResponse => {
				if (typeof callback === 'function') {
					callback(jsonResponse);
				}
				setResponse(jsonResponse);
				onSuccess(jsonResponse);
			})
			.catch(error => {
				setError(error);
				onError(error);
			});
	}

	return {
		request: useDebouncedCallback(args => {
			doRequest(args);
		}, 200),
		response,
		error,
		cancel: cancel.current
	};
}
